// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22H22V2H2V22ZM15.5 12L10 16.25V7.75L15.5 12Z"}}]};

const ChevronRightRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right-rectangle-filled',
    ref,
    icon: element,
  },
));

ChevronRightRectangleFilledIcon.displayName = 'ChevronRightRectangleFilledIcon';

export default ChevronRightRectangleFilledIcon;
